import { getColorGradient } from "../utils/helpers";

export const PercentileColorKey = () => {
  const labels = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90];
  const colors = labels.map((value: number) => getColorGradient(value).backgroundColor);
  return (
    <span className="colorKeyContainer">
      <span className="colorKeyLabel">Client Percentile:</span>
      {
        colors.map((color, index) => {
          return (
            <div key={index} className="colorKeyItem">
              <div
                className="colorSwatch"
                style={{ backgroundColor: color }}
              ></div>
                <div
                  className="colorSwatchLabel"
                  style={{ color: "#eef2f8" }}
                >{labels[index]}</div>
            </div>
          )
        })
      }
    </span>
  );
};

export default PercentileColorKey;